import React from 'react'

import { IWelcomeStepProps } from './interface'
import './styles.scss'

const bc = 'welcome-step'

const WelcomeStep: React.FC<IWelcomeStepProps> = ({ title }) => {
  return (
    <div className={`${bc}__wrapper`}>
      <img src="https://prohabits-user-profile-prod.s3-us-west-2.amazonaws.com/prohabits/people.png" alt="People" />
      <div className={`${bc}__text`} dangerouslySetInnerHTML={{ __html: title }} />
    </div>
  )
}

export default WelcomeStep
